import { HttpInterceptorFn } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { ATTRIBUTION_HEADER, attributionHeaderValue } from "./attribution.util";

/**
 * Sends where the visitor came from (see attribution.util.ts) along with requests to our backend that change
 * something, like starting an installation or registering. Not with GET requests: a custom header makes the browser
 * do a CORS preflight, and our (public) GET requests don't need one now.
 */
export const attributionInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.method !== "GET" && req.url.startsWith(environment.backendEndpoint)) {
    const value = attributionHeaderValue();
    if (value) {
      return next(req.clone({setHeaders: {[ATTRIBUTION_HEADER]: value}}));
    }
  }
  return next(req);
};
